import MyCustomLogoIcon from './Waadoo.cloud.png';

export const LogoIcon = () => {
  return (
    <img src={MyCustomLogoIcon} style={{ height: 28, width: 'auto' }} alt="" />
  );
};
